import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginForm from './pages/LoginForm';
import RegistroForm from './pages/RegistroForm';
import Database from './pages/Database';
import Usuarios from './pages/Usuarios';
import Actividades from './pages/Actividades';
import Dashboard from './pages/Dashboard';
import NoAutorizado from './pages/NoAutorizado';
import SupervisorView from './pages/SupervisorView';
import PlanTrabajo from './pages/PlanTrabajo';
import PlanMensual from './pages/PlanMensual';
import Precipitacion from './pages/Precipitacion';
import PlanOperativo from './pages/plan-operativo/PlanOperativo';
import ResumenMes from './pages/plan-operativo/ResumenMes';

import ProtectedRoute from './components/routing/ProtectedRoute';
import Footer from './components/layout/Footer';
import { AuthProvider } from './context/AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Router>
          <div style={{ minHeight: 'calc(100vh - 50px)', display: 'flex', flexDirection: 'column' }}>
            <Routes>
              {/* Ruta para el login */}
              <Route path="/login" element={<LoginForm />} />

              {/* Rutas protegidas para diferentes roles */}
              <Route
                path="/registro-operario"
                element={
                  <ProtectedRoute allowedRoles={['Admin', 'Lider', 'Gestor', 'Supervisor']}>
                    <RegistroForm />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/database"
                element={
                  <ProtectedRoute allowedRoles={['Admin', 'Lider', 'Gestor']}>
                    <Database />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/usuarios"
                element={
                  <ProtectedRoute allowedRoles={['Admin', 'Lider', 'Gestor']}>
                    <Usuarios />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/actividades"
                element={
                  <ProtectedRoute allowedRoles={['Admin']}>
                    <Actividades />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/supervisor"
                element={
                  <ProtectedRoute allowedRoles={['Admin', 'Supervisor']}>
                    <SupervisorView />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute allowedRoles={['Admin']}>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/precipitacion"
                element={
                  <ProtectedRoute allowedRoles={['Admin', 'Lider', 'Gestor', 'Supervisor']}>
                    <Precipitacion />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/plan-trabajo"
                element={
                  <ProtectedRoute allowedRoles={['Admin', 'Lider', 'Gestor']}>
                    <PlanTrabajo />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/plan-mensual"
                element={
                  <ProtectedRoute allowedRoles={['Admin', 'Lider', 'Gestor']}>
                    <PlanMensual />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/plan-operativo"
                element={
                  <ProtectedRoute allowedRoles={['Admin', 'Lider', 'Gestor']}>
                    <PlanOperativo />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/plan-operativo/resumen"
                element={
                  <ProtectedRoute allowedRoles={['Admin', 'Lider', 'Gestor']}>
                    <ResumenMes />
                  </ProtectedRoute>
                }
              />

              {/* Ruta para no autorizado */}
              <Route path="/no-autorizado" element={<NoAutorizado />} />

              {/* Ruta por defecto: Redirige a dashboard según el rol del usuario */}
              <Route
                path="*"
                element={<DefaultRedirect />}
              />
            </Routes>
          </div>
          <Footer />
        </Router>
      </AuthProvider>
    </div>
  );
}

// Componente de redirección según el rol del usuario
const DefaultRedirect = () => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  const role  = localStorage.getItem('role')  || sessionStorage.getItem('role');

  if (!token || !role) {
    return <Navigate to="/login" replace />;
  }

  switch (role) {
    case 'Admin':
      return <Navigate to="/database" replace />;
    case 'Lider':
      return <Navigate to="/database" replace />;
    case 'Gestor':
      return <Navigate to="/database" replace />;
    case 'Supervisor':
      return <Navigate to="/registro-operario" replace />;
    case 'Operario':
      return <Navigate to="/no-autorizado" replace />;
    default:
      return <Navigate to="/no-autorizado" replace />;
  }
};

export default App;
